import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgQuestionMarkCircleLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M12 16.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M9.283 6.364c.756-.589 1.734-.868 2.717-.864.984-.004 1.961.275 2.717.864A3.27 3.27 0 0 1 16 9c0 .935-.24 1.652-.666 2.225-.37.498-.849.834-1.191 1.074l-.067.047c-.383.27-.616.452-.784.695-.148.214-.292.551-.292 1.192a1 1 0 1 1-2 0c0-.976.23-1.726.646-2.327.392-.57.904-.93 1.27-1.189l.008-.005c.405-.286.636-.453.805-.68C13.865 9.848 14 9.565 14 9c0-.466-.192-.809-.513-1.059-.341-.266-.862-.444-1.481-.44h-.011c-.62-.004-1.14.174-1.482.44C10.192 8.192 10 8.535 10 9c0 .23.047.42.12.577a1 1 0 1 1-1.812.846A3.34 3.34 0 0 1 8 9c0-1.118.505-2.03 1.283-2.636'
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M3.793 3.793C5.713 1.873 8.513 1 12 1s6.287.873 8.207 2.793S23 8.513 23 12s-.872 6.287-2.793 8.207C18.287 22.127 15.487 23 12 23s-6.287-.872-8.207-2.793C1.873 18.287 1 15.487 1 12s.873-6.287 2.793-8.207m1.414 1.414C3.794 6.62 3 8.821 3 12s.794 5.38 2.207 6.793S8.821 21 12 21s5.38-.794 6.793-2.207S21 15.179 21 12s-.794-5.38-2.207-6.793S15.179 3 12 3s-5.38.794-6.793 2.207'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgQuestionMarkCircleLine)
export default ForwardRef
